//根据环境变量获取当前域名池初始化数据
const DomainPool = {
    getCurrentPool: function(env) {
        const dev = ['bs0906.com', 'baison001.com'],
            test = ['gpsyour.com'],
            dist = ['ddomi.com', 'hyxtong.com', 'uniddi.com', 'gcpadi.com', '33yipu.com'];
        switch (env) {
            case 'dev':
                return dev;
            case 'test':
                return test;
            case 'dis':
                return dist;
            default:
                return dev;
        }
    }
}


export default DomainPool;